import { Avatar, Box, Button, CircularProgress, Grid, Paper, Stack, TextField } from "@mui/material"
import React, { useEffect, useState } from "react"
import Modal from "react-bootstrap/Modal"
import apiClient from "../api/apiClient"
import { useDispatch } from "react-redux"
import { logout } from "../redux/counterSlice"
import { useOutletContext } from "react-router-dom"
const Profile = ({ role }) => {
  const [load, setLoad] = useState(false)
  const [modalShow, setModalShow] = React.useState(false)
  const { setRefresh, user } = useOutletContext()
  // console.log(user,"lllll");
  let initialState = {
    profile: "",
    contact: "",
    name: ""
  }
  const [profile, setProfile] = useState(initialState)
  const [twoFactor, setTwoFactor] = useState({
    email: "",
    code: "",
    codeSent: false,
    loading: false,
    message: ""
  })
  // console.log(profile,"lllll");
  useEffect(() => {
    if (user && role === "AD")
      setProfile({
        contact: user?.data.contact || "",
        name: user?.data.name || ""
      })

    if (user?.data) {
      setTwoFactor(current => ({
        ...current,
        email: user.data.twoFactor?.email || user.data.email || "",
        code: "",
        codeSent: false,
        message: ""
      }))
    }
  }, [user])

  const handleChange = (key, value) => {
    setProfile({ ...profile, [key]: value })
  }
  const handleSubmit = async e => {
    setLoad(true)
    e.preventDefault()
    // console.log(profile);
    const formdata = new FormData()
    formdata.append("profile", profile.profile)
    if (role == "AD") {
      formdata.append("name", profile.name)
      formdata.append("contact", profile.contact)
    }
    const result = await apiClient.put("/auth/user", formdata)
    setLoad(false)
    setRefresh(true)
    // console.log(result);
  }

  const sendTwoFactorCode = async e => {
    e.preventDefault()
    setTwoFactor(current => ({ ...current, loading: true, message: "" }))

    const result = await apiClient.post("/auth/2fa/setup/send", {
      email: twoFactor.email
    })

    setTwoFactor(current => ({
      ...current,
      loading: false,
      codeSent: result.ok,
      message: result.ok
        ? "Verification code sent. Check the email address above."
        : result.data?.message || "Could not send verification code."
    }))
  }

  const verifyTwoFactorCode = async e => {
    e.preventDefault()
    setTwoFactor(current => ({ ...current, loading: true, message: "" }))

    const result = await apiClient.post("/auth/2fa/setup/verify", {
      code: twoFactor.code
    })

    setTwoFactor(current => ({
      ...current,
      loading: false,
      codeSent: !result.ok,
      code: "",
      message: result.ok
        ? "Two-factor authentication is now enabled."
        : result.data?.message || "Could not verify code."
    }))

    if (result.ok) setRefresh(true)
  }

  const disableTwoFactor = async () => {
    setTwoFactor(current => ({ ...current, loading: true, message: "" }))

    const result = await apiClient.delete("/auth/2fa/setup")

    setTwoFactor(current => ({
      ...current,
      loading: false,
      codeSent: false,
      code: "",
      message: result.ok
        ? "Two-factor authentication is disabled."
        : result.data?.message || "Could not disable two-factor authentication."
    }))

    if (result.ok) setRefresh(true)
  }

  const isTwoFactorEnabled = !!user?.data?.twoFactor?.enabled

  return (
    <Box sx={{ px: { xs: 2, md: 3 } }}>
      <Box sx={{ maxWidth: 980, mx: "auto" }}>
        <Box sx={{ mb: 3 }}>
          <h3 className="mb-1">Profile</h3>
          <p className="mb-0 text-muted">Manage your account details, profile photo, and security settings.</p>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={0}
              sx={{
                border: "1px solid #E5E7EB",
                borderRadius: 3,
                boxShadow: "0 16px 36px rgba(15, 23, 42, 0.08)",
                p: { xs: 2.5, md: 3 }
              }}
            >
          <form onSubmit={handleSubmit}>
            <Stack spacing={3}>
                <Box
                  sx={{
                    alignItems: "center",
                    backgroundColor: "#F8FAFC",
                    border: "1px solid #E5E7EB",
                    borderRadius: 2,
                    display: "flex",
                    gap: 2,
                    p: 2
                  }}
                >
                  {profile.profile ? (
                    <Avatar
                      src={URL.createObjectURL(profile.profile)}
                      // src={formData.previewImage}
                      alt="Remy Sharp"
                      sx={{ width: 100, height: 100 }}
                    />
                  ) : (
                    <Avatar
                      src={user?.data.profile}
                      // src={formData.previewImage}
                      alt="Remy Sharp"
                      sx={{ width: 100, height: 100 }}
                    />
                  )}
                  <Box>
                    <h5 className="mb-1">Profile Picture</h5>
                    <p className="mb-2 text-muted fs_14px">Upload an image under 1MB.</p>
                    <Button component="label" variant="outlined" sx={{ borderRadius: "999px" }}>
                      Choose Image
                      <input
                        hidden
                        type="file"
                        onChange={e => handleChange("profile", e.target.files[0])}
                        accept="image/*"
                      />
                    </Button>
                  </Box>
                </Box>

                {role === "AD" && (
                  <Stack spacing={2}>
                        <TextField
                          required
                          label="Name"
                          type="text"
                          value={profile.name}
                          onChange={e => handleChange("name", e.target.value)}
                          fullWidth
                        />
                        <TextField
                          required
                          label="Phone Number"
                          type="number"
                          value={profile.contact}
                          onChange={e => handleChange("contact", e.target.value)}
                          fullWidth
                        />

                    <div className="d-flex justify-content-end">
                      <Button onClick={() => setModalShow(true)} sx={{ borderRadius: "999px" }}>
                        Change Password
                      </Button>
                    </div>
                  </Stack>
                )}
            {!load ? (
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button type="submit" variant="contained" className="btn_bg_secondery text-white" sx={{ borderRadius: "999px", minWidth: 120 }}>
                  Save
                </Button>
              </Box>
            ) : (
              <div className=" w-100 d-flex justify-content-center align-items-center">
                <CircularProgress />
              </div>
            )}
            </Stack>
          </form>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
          <Paper
            elevation={0}
            sx={{
              border: "1px solid #E5E7EB",
              borderRadius: 3,
              boxShadow: "0 16px 36px rgba(15, 23, 42, 0.08)",
              p: { xs: 2.5, md: 3 }
            }}
          >
            <div className="d-flex justify-content-between align-items-start flex-column flex-sm-row gap-2">
              <div>
                <h4 className="mb-1">Two-Factor Authentication</h4>
                <p className="mb-0 text-muted">
                  {isTwoFactorEnabled
                    ? `Enabled for ${user?.data?.twoFactor?.email}`
                    : "Add an email address and verify it to require an OTP at login."}
                </p>
              </div>
              {isTwoFactorEnabled && (
                <Button
                  className="btn_bg_secondery text-white"
                  variant="contained"
                  onClick={disableTwoFactor}
                  disabled={twoFactor.loading}
                >
                  Disable
                </Button>
              )}
            </div>

            {!isTwoFactorEnabled && (
              <>
                <form onSubmit={sendTwoFactorCode} className="mt-3">
                  <TextField
                    fullWidth
                    required
                    type="email"
                    label="2FA email address"
                    value={twoFactor.email}
                    onChange={e => setTwoFactor({ ...twoFactor, email: e.target.value })}
                    variant="outlined"
                  />
                  <div className="d-flex justify-content-end mt-3">
                    <Button
                      className="btn_bg_secondery text-white"
                      type="submit"
                      variant="contained"
                      disabled={twoFactor.loading}
                    >
                      Send verification code
                    </Button>
                  </div>
                </form>

                {twoFactor.codeSent && (
                  <form onSubmit={verifyTwoFactorCode} className="mt-3">
                    <TextField
                      fullWidth
                      required
                      label="Verification code"
                      value={twoFactor.code}
                      onChange={e =>
                        setTwoFactor({ ...twoFactor, code: e.target.value.replace(/\D/g, "") })
                      }
                      inputProps={{ maxLength: 6, inputMode: "numeric" }}
                      variant="outlined"
                    />
                    <div className="d-flex justify-content-end mt-3">
                      <Button
                        className="btn_bg_secondery text-white"
                        type="submit"
                        variant="contained"
                        disabled={twoFactor.loading}
                      >
                        Verify and enable
                      </Button>
                    </div>
                  </form>
                )}
              </>
            )}

            {twoFactor.loading && (
              <div className="d-flex justify-content-center mt-3">
                <CircularProgress size={24} />
              </div>
            )}
            {twoFactor.message && <p className="mt-3 mb-0">{twoFactor.message}</p>}
          </Paper>
          </Grid>
        </Grid>
      </Box>
      <MyVerticallyCenteredModal show={modalShow} onHide={() => setModalShow(false)} />
    </Box>
  )
}

export default Profile

function MyVerticallyCenteredModal(props) {
  const dispatch = useDispatch()
  let initialState = {
    current: "",
    newpassword: "",
    rePassword: ""
  }
  const [password, setPassword] = useState(initialState)
  const handleChange = (key, value) => {
    setPassword({ ...password, [key]: value })
  }
  const handleSubmit = async e => {
    e.preventDefault()
    if (password.newpassword != password.rePassword) {
      return console.log("object")
    }

    const result = await apiClient.patch("/auth/updateMyPassword", {
      passwordCurrent: password.current,
      password: password.newpassword
    })
    // console.log(result);
    props.onHide()
    dispatch(logout())
  }
  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Change Password</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div class="py-1 ">
            <label for="" class="form-label white_space">
              Current Password{" "}
            </label>
            <div class=" mb-3">
              <input
                required
                type="password"
                value={password.current}
                onChange={e => handleChange("current", e.target.value)}
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-default"
              />
            </div>
          </div>
          <div class="py-1 ">
            <label for="" class="form-label white_space">
              Enter Password{" "}
            </label>
            <div class=" mb-3">
              <input
                required
                type="password"
                value={password.newpassword}
                onChange={e => handleChange("newpassword", e.target.value)}
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-default"
              />
            </div>
          </div>

          <div class="py-1 ">
            <label for="" class="form-label white_space">
              Reenter Password{" "}
            </label>
            <div class=" mb-3">
              <input
                required
                type="password"
                value={password.rePassword}
                onChange={e => handleChange("rePassword", e.target.value)}
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-default"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit">Save</Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}
